/* GLADIUS · Shilajit. Gallery, offers, tabs, scroll motion, sticky bar. */
(function () {
  var root = document.getElementById('gsh');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  root.classList.add('gsh-js');
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var preview = root.dataset.preview === '1';

  /* Gallery: click the labels, or swipe on mobile */
  var shots = $$('.gsh-shot'), thumbs = $$('.gsh-thumbs button'), cur = 0;
  function show(i) {
    cur = (i + shots.length) % shots.length;
    shots.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.go); }); });
  var main = $('.gsh-gallery__main'), x0 = null;
  main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  main.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
  });

  /* Offers: the button shows the selected price */
  var priceEls = $$('[data-gsh-price]');
  function syncPrice() {
    var c = $('.gsh-offer input:checked');
    var p = c ? c.dataset.price : '';
    priceEls.forEach(function (el) { el.textContent = p; });
  }
  root.addEventListener('change', function (e) { if (e.target.name === 'id') syncPrice(); });
  syncPrice();

  /* Preview mode: no real cart */
  var form = $('.gsh-form'), dialog = $('.gsh-dialog');
  form.addEventListener('submit', function (e) {
    if (!preview) { $('[data-gsh-add]').setAttribute('aria-busy', 'true'); return; }
    e.preventDefault();
    var c = $('.gsh-offer input:checked');
    $('[data-gsh-picked]').textContent = c ? c.dataset.label : '-';
    if (dialog.showModal) dialog.showModal();
  });

  /* Videos: load and play only while visible */
  var vids = $$('video');
  var vio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (v.dataset.src && !v.src) { v.src = v.dataset.src; }
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else { v.pause(); }
    });
  }, { rootMargin: '200px 0px' });
  vids.forEach(function (v) { v.muted = true; vio.observe(v); });

  /* From price in the hero */
  var first = $('.gsh-offer input');
  $$('[data-gsh-from]').forEach(function (el) { el.textContent = first ? first.dataset.price : ''; });

  /* Tabs */
  var tabs = $$('.gsh-tabs__nav button'), panes = $$('.gsh-pane');
  function tab(i) {
    tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    panes.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
  }
  tabs.forEach(function (t, k) {
    t.addEventListener('click', function () { tab(k); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = (k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tab(n); tabs[n].focus(); }
    });
  });

  /* Smooth jump back to the product */
  $$('[data-gsh-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      $('#gsh-buy').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* Ridges: measure each line so it draws itself */
  $$('.gsh-ridge').forEach(function (p) { try { p.style.setProperty('--len', Math.ceil(p.getTotalLength()) + 10); } catch (e) {} });

  /* Words that light up as you scroll */
  $$('[data-words]').forEach(function (el) {
    (function wrap(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            var s = document.createElement('span'); s.className = 'gsh-w'; s.textContent = w; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) wrap(n);
      });
    })(el);
  });
  var words = $$('.gsh-w');

  /* Reveal on scroll */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
  $$('.gsh-reveal, .gsh-curtain, .gsh-mountain').forEach(function (el) { io.observe(el); });

  /* Scroll-driven: steps line, lit words, sticky bar */
  var steps = null, stepItems = [], bar = $('.gsh-bar'), panel = $('.gsh-form'), final = $('.gsh-final');
  var ticking = false;
  function onScroll() {
    ticking = false;
    var vh = window.innerHeight;
    if (steps) {
      var r = steps.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (vh * .6 - r.top) / r.height));
      steps.style.setProperty('--p', p.toFixed(3));
      stepItems.forEach(function (li) { li.classList.toggle('is-lit', li.getBoundingClientRect().top < vh * .6); });
    }
    words.forEach(function (w) { w.classList.toggle('is-lit', w.getBoundingClientRect().top < vh * .72); });
    if (bar) {
      var past = panel.getBoundingClientRect().bottom < 0;
      var atEnd = final.getBoundingClientRect().top < vh * .5;
      bar.classList.toggle('is-on', past && !atEnd);
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();
